import axios from 'lib/axios';

const getAllAdmins = async () => {
  const { data } = await axios.get('/admin');
  return data;
};

export { getAllAdmins };
